import { IValidationService } from '../models/interfaces/iValidationService.interface';
import { Injectable } from '@angular/core';
import { ValidationResult } from '../models/validationresult.model';
import { ComponentChanged } from '../helper/componentChanged.model';
import { ComponentNames } from '../helper/componentNames';

@Injectable({providedIn:'root'})
export class PropertyWindowValidationService implements IValidationService {
    private additionalData: string[];

    isValid(data): ValidationResult {
        let resultData: string[] = new Array();
        let isValid = true;
        data.forEach((element: ComponentChanged) => {

            switch (element.type) {
                case ComponentNames.namingComponent:
                    this.validateNamingComponent(element, resultData);
                    break;
                case ComponentNames.identificationComponent:
                    this.validateIdentificationComponent(element, resultData);
                    break;
                default:
                    break;
            }
        });

        if (resultData.length > 0)
            isValid = false;

        return new ValidationResult(isValid, resultData);
    }

    setAdditionalDataForValidation(data: any) {
        this.additionalData = data;
    }

    validateNamingComponent(element: ComponentChanged, resultData: string[]) {
        if (element.getCurrentValue() === '') {
            let errMsg = "Name can't be empty!";
            resultData.push(errMsg);
        }
    }

    validateIdentificationComponent(element: ComponentChanged, resultData: string[]) {
        let value: string = element.getCurrentValue();
        if (value === '') {
            let errMsg = "Identifier name can't be empty!";
            resultData.push(errMsg);
        }
        if (!this.isUniqueIdentifier(value)) {
            let errMsg = "An object with the identifier: "+value + " already exists.The identifier must be unique!";
            resultData.push(errMsg);
        }
    }

    isUniqueIdentifier(value: string): boolean {
        let isUnique = true;
        if (this.additionalData.includes(value)) {
            isUnique = false;
        }
        return isUnique;
    }
}